import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ISurveyors } from 'app/models/core/admin/surveyors';
import { IEvaluatorList, IPcaIndexAgency, IPtTestList } from 'app/models/core/admin/masterTables';
import { ISpecialtyCategory } from 'app/models/core/admin/specialtyCategory';
import { IRelicenseLab } from 'app/models/core/admin/registrationLicense';
import { ILabLicense } from 'app/models/core/admin/labLicense';
import { IPtExceptionReport, IPtListReport } from 'app/models/core/admin/ptReports';
import { IUploadPtData } from 'app/models/core/admin/uploadPt';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  }),
  withCredentials: true
};

@Injectable({ providedIn: 'root' })

export class AdminService {
  private api: string = environment.privateApi + 'Admin/';

  currentTab = 0;

  constructor(private http: HttpClient) { };

  // ******************** Manage Master Tables **************
  // ******************** Evaluator List ********************
  getEvaluatorCodes(): Observable<IEvaluatorList[]> {
    return this.http.get<IEvaluatorList[]>(this.api + 'getEvaluatorCodes'
      , { withCredentials: true });
  };

  saveEvaluator(data: IEvaluatorList, action: string): Observable<any> {
    return this.http.post(this.api + 'saveEvaluator/' + action, data, httpOptions)
  };

  // ******************** Pca Index Agency ********************
  getPcaIndexAgency(): Observable<IPcaIndexAgency> {
    return this.http.get<IPcaIndexAgency>(this.api + 'getPcaIndexAgency'
      , { withCredentials: true });
  };

  savePcaIndexAgency(data: IPcaIndexAgency): Observable<any> {
    return this.http.post(this.api + 'savePcaIndexAgency', data, httpOptions)
  };

  // **************************** PT *************************
  getPtList(): Observable<IPtTestList[]> {
   return this.http.get<IPtTestList[]>(this.api + 'getPtList'
      , { withCredentials: true });
  };

  savePtTestCategory(data: IPtTestList, action: string): Observable<any> {
    return this.http.post(this.api + 'savePtTestCategory/' + action, data, httpOptions)
  };

  // ******************** Specialty Categories ********************
  getSpecialtyCategories(): Observable<ISpecialtyCategory[]> {
   return this.http.get<ISpecialtyCategory[]>(this.api + 'getSpecialtyCategories'
      , { withCredentials: true });
  };

  saveSpecialtyCategory(data: ISpecialtyCategory, action: string): Observable<any> {
    return this.http.post(this.api + 'saveSpecialtyCategory/' + action, data, httpOptions)
  };

  // ************************ Surveyors ****************************
  getSurveyors(): Observable<ISurveyors[]> {
    return this.http.get<ISurveyors[]>(this.api + 'getSurveyors'
      , { withCredentials: true });
  };

  saveSurveyors(data: ISurveyors, action: string): Observable<any> {
    return this.http.post(this.api + 'saveSurveyors/' + action, data, httpOptions)
  };

  // *********************** Upload PT *********************************
  // *******************************************************************
  uploadPt(data: FormData, evalType: string): Observable<IUploadPtData[][]> {
    return this.http.post<IUploadPtData[][]>(this.api + 'uploadPt/' + evalType, data, 
      { withCredentials: true })
  };

  savePtTests(tests:IUploadPtData[][]): Observable<any> {
    return this.http.post(this.api + 'savePtTests', tests
      , { withCredentials: true });
  };


  // *********************** View PT Reports ***************************
  // *******************************************************************
  getExceptionMasterList(): Observable<IPtListReport[]> {
    return this.http.get<IPtListReport[]>(this.api + 'getExceptionMasterList'
      , { withCredentials: true });
  };

  getPtExceptionReports(id : string): Observable<IPtExceptionReport[]> {
    return this.http.get<IPtExceptionReport[]>(this.api + 'getPtExceptionReports/' + id
      , { withCredentials: true });
  };

  // *********************** CLIA Updates ******************************
  // *******************************************************************




  // *********************** Registration/License Manager ***************
  // *********************** Print Lab Licenses *************************
  getVerifyLabs(type:string, date: string, stateNum: string): Observable<ILabLicense[]> {
    return this.http.get<ILabLicense[]>(this.api + 'getVerifyLabs/' + type  + '/' + stateNum
      + '/' + date
      , { withCredentials: true });
  };
  
  getLabLicensesReport(type:string, stateNum: string): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'getLabLicensesReport/' + type  + '/' + stateNum
    , { responseType: 'blob' as 'json', withCredentials: true });
  }

  printCurrentHstLicense(stateNum:string): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'printCurrentHstLicense/' + stateNum, 
    { responseType: 'blob' as 'json', withCredentials: true });
  }

  printCurrentSoaLicense(stateNum:string): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'printCurrentSoaLicense/' + stateNum, 
    { responseType: 'blob' as 'json', withCredentials: true });
  }

  printSingleLicense(id:number , type: string, stateNum: string): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'printSingleLicense/' + id + '/' + type + '/' + stateNum, 
    { responseType: 'blob' as 'json', withCredentials: true });
  }

  // ************************ Print Renewal Forms ***********************
  printRenewalForms(type:string, stateNum: string): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'printRenewalForms/' + type  + '/' + stateNum
    , { responseType: 'blob' as 'json', withCredentials: true });
  }

  // ************************ Relicense Labs ****************************
  relicenseLabs(licenseDate:string, relicenseType:string): Observable<IRelicenseLab[]> {
    return this.http.get<IRelicenseLab[]>(this.api + 'relicenseLabs/' + relicenseType + '/' + 
      licenseDate, { withCredentials: true });
  };

}
